import React from 'react'
import { useSelector } from 'react-redux'
import { Locale, Translation } from 'locale'
import { TextButtonType, TextButton } from 'view/components/buttons'
import { useNewHaircutDialog } from './useHaircutActions'
import { canManageHaircutsSelector } from 'selectors/permissionSelectors'
import { useIsCurrentOrganisationSellSide } from 'view/hooks'

export const HaircutToolbar = () => {
  const canManageHaircuts = useSelector(canManageHaircutsSelector)
  const isSellSideOrganisation = useIsCurrentOrganisationSellSide()
  const addNewHaircut = useNewHaircutDialog()

  if (!canManageHaircuts || !isSellSideOrganisation) {
    return null
  }

  return (
    <TextButton dataTestId={'HaircutToolbar-TextButton-AddHaircut'} type={TextButtonType.Primary} onClick={addNewHaircut}>
      {Locale.translate(Translation.TC_BUTTON_NEW_HAIRCUT)}
    </TextButton>
  )
}
